export default {
  most_popular: '#{{rank}} Most Liked',
};
